import { EmptyPage } from '../empty-page/EmptyPage';

export const Services = () => {
  return <EmptyPage />;
};
